<template>
  <div class="reservation-box">
    <menuBox :step="4"></menuBox>
    <div class="content-top">
      <div class="title">layanan kami</div>
      <div class="text">Rumah/Layanan</div>
    </div>
    <div class="content">
      layanan kami<br>
      1. Pembuatan Film Pribadi<br>
      Kami memberi Anda berbagai layanan produksi film swasta mulai dari konsep kreatif hingga film akhir. Baik itu film
      pendek pribadi atau film panjang, tim profesional kami akan menyesuaikan plot, karakter, dan visual sesuai
      kebutuhan Anda, memastikan setiap produksi menampilkan kisah unik dan kepribadian Anda.<br>
      2. Produksi video<br>
      Kami berspesialisasi dalam memproduksi konten video khusus berkualitas tinggi, termasuk video promosi, video
      perusahaan, rekaman acara, dan film pendek pribadi. Tim kami akan menggunakan teknik pengambilan gambar dan
      pasca-pengeditan yang luar biasa untuk menampilkan konsep dan merek Anda dengan sempurna, membantu Anda menonjol
      di antara banyak pesaing.<br>
      3. Produksi acara TV<br>
      Dari perencanaan program hingga produksi, kami menyediakan berbagai layanan produksi program televisi. Baik itu
      program hiburan, talkshow, atau dokumenter, kami dapat menyediakan perencanaan kreatif, pembuatan film,
      pengeditan, dan pasca produksi sesuai kebutuhan Anda. Kami berkomitmen untuk menghasilkan program berkualitas
      tinggi yang menghibur dan mendalam.<br>
      4. Pembuatan dan perencanaan naskah<br>
      Tim penulis naskah kami terdiri dari penulis berpengalaman yang dapat menulis naskah asli berdasarkan kebutuhan
      dan visi Anda. Kami menyediakan layanan perencanaan mulai dari konsepsi kreatif, desain plot hingga naskah
      lengkap, memastikan setiap cerita memiliki plot yang menarik dan karakter yang khas.<br>
      5. Pasca produksi<br>
      Kami menyediakan layanan pasca produksi profesional termasuk pengeditan, efek khusus, koreksi warna, dan desain
      suara. Tim kami menggunakan perangkat lunak dan alat canggih untuk memoles rekaman menjadi produk jadi berkualitas
      tinggi, memastikan bahwa setiap detail diproses dengan cermat untuk memberi Anda pengalaman visual dan pendengaran
      yang sempurna.<br>
      6. Konsultasi kreatif<br>
      Jika Anda memerlukan bimbingan atau saran kreatif di tahap awal suatu proyek, layanan konsultasi kreatif kami akan
      memberi Anda saran dan solusi profesional. Baik pada tahap konsepsi atau selama implementasi, tim ahli kami akan
      membantu Anda mengoptimalkan ide dan meningkatkan kualitas proyek Anda.<br>

      Kami berkomitmen untuk memberi Anda layanan produksi film dan televisi yang komprehensif dan profesional, dan kami
      mengupayakan kesempurnaan mulai dari konsep kreatif hingga presentasi akhir. Apapun kebutuhan Anda, tim kami
      bekerja keras untuk memastikan setiap proyek diselesaikan dengan standar tertinggi. Selamat datang untuk
      menghubungi kami dan memulai perjalanan film dan televisi Anda bersama!<br>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "reservation",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
    sendInfo() {
      alert('ส่งเรียบร้อยแล้ว')
    }
  },
};
</script>
<style lang="less" scoped>
.reservation-box {
  background: #F4F8FB;

  .content-top {
    padding: 200px 312px 0;
    background-image: url(../assets/projects.png);
    width: 100%;
    height: 640px;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;
    text-align: center;

    .title {
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 56px;
      color: #FFFFFF;
      line-height: 79px;
    }

    .text {
      font-weight: bold;
      font-size: 24px;
      color: #E5D806;
      line-height: 33px;
    }
  }
}

.content {
  padding: 100px 312px;
  background: #1E1D21;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 40px;
}
</style>
